function normalizeRates(response) {
    const { providers, rates, primeRate, ...additionalProperties } = deepClone(response); // normalizeRates would otherwise mutate the params

    // If the provider is brokered, replaces the brokerage slug with the brokerage object for easy access
    Object.values(providers)
        .filter(provider => {
            try {
                return provider.brokerage;
            } catch {
                throw new Error (`[normalizeRates] A brokerage for ${provider.name} was not found`);
            }
        }) // Ensure we only mutate a provider if there is a brokerage
        .forEach(provider =>
            provider.brokerage = providers[provider.brokerage],
        );

    // normalize rate response
    rates.forEach((rate) => {
        const rateProvider = providers[rate.provider];
        if (rateProvider == null) {
            throw new Error (`[normalizeRates] There is no ${rate.provider} provider within the returned providers object.`);
        } else {
            rate.provider = rateProvider;
            rate.primeRate = primeRate; // The Lead Form requires primeRate, but it is only passed a single rate. Therefore primeRate is added here as well
        }
    });

    // add additional properties to normalized rates return
    //  note: object properties are not included when iterating over array items
    return Object.assign(rates, {
        ...additionalProperties,
        providers,
        primeRate,
    });
}

function deepClone(object) {
    return JSON.parse(JSON.stringify(object));
}

export default normalizeRates;